/* eslint-disable */
(function() {
  var $ = require('jquery');

  var $loginarea = $('.login-area');

  function loginDesktop() {
    var $loginClick = $loginarea.find('.login-click');
    $loginClick.click(function() {
      var $this = $(this);
      var $dropLogin = $this.siblings('.drop-login');

      if ($dropLogin.hasClass('open')) {
        $dropLogin.removeClass('open');
        $dropLogin.stop().slideUp();
      } else {
        $dropLogin.addClass('open');
        //slides down the login and focuses
        $dropLogin.stop().slideDown();
        $dropLogin.find('.input-box:first-child input').focus();
      }
    });
  }

  function loginMobile() {
    var $loginClick = $loginarea.find('.login-click');

    $loginClick.click(function() {
      var $this = $(this);
      var $dropLogin = $this.siblings('.drop-login');

      var $ipadSearch = $('.ipad-search');

      //slides up the search dropdown if open and removes class
      if ($ipadSearch.hasClass('active')) {
        $ipadSearch.removeClass('active');
        $('.ipad-search .drop-search')
          .stop()
          .slideUp();
      }

      //slides down the login
      $loginarea.toggleClass('active');
      $dropLogin.stop().slideToggle();
    });
  }

  function countryDrop() {
    var $dropClick = $('.selected-country a');

    $dropClick.click(function(e) {
      e.preventDefault();

      var $this = $(this);
      var $dropCountries = $this.parent().siblings('.other-coutries');

      //slides up the country dropdown if open and removes class
      if (!$this.parent().hasClass('open')) {
        $this.parent().addClass('open');
        $dropCountries.slideDown();
      } else {
        $this.parent().removeClass('open');
        $dropCountries.slideUp();
      }
    });
  }

  countryDrop();

  if ($(window).innerWidth() > 991) {
    loginDesktop();
  } else {
    loginMobile();
  }

  $(window).resize(function() {
    //resize viewport function
    function viewport() {
      var e = window,
        a = 'inner';
      if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
      }
      return {
        width: e[a + 'Width'],
        height: e[a + 'Height'],
      };
    }

    $loginarea.unbind();

    if (viewport().width >= 991) {
      loginDesktop();
    } else {
      loginMobile();
    }
  });
})();
